export enum BreakpointSize {
  xsmall,
  small,
  medium,
  large,
  xlarge,
}

type Breakpoint = {
  name: BreakpointSize;
  breakpoint: number;
};

export const connectElementBreakpoints: Breakpoint[] = [
  {name: BreakpointSize.xsmall, breakpoint: 0},
  {name: BreakpointSize.small, breakpoint: 490},
  {name: BreakpointSize.medium, breakpoint: 768},
  {name: BreakpointSize.large, breakpoint: 1040},
  {name: BreakpointSize.xlarge, breakpoint: 1440},
];

export const defaultBreakpoint = BreakpointSize.medium;

// Minimum width of connect elements
export const MIN_WIDTH = 320;
